import React from 'react';

import { Link, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { isSupported as isBrowserSupported } from 'twilio-video';

import { useStyles } from './TelehealthBrowserNotSupportedBanner.useStyles';

interface TelehealthBrowserNotSupportedBannerProps {
  classes: any;
  className?: string;
  extraClasses?: {
    text: string;
  };
}

const TelehealthBrowserNotSupportedBanner: React.FC<TelehealthBrowserNotSupportedBannerProps> = (props) => {
  const { classes, className, extraClasses = { text: '' } } = props;

  if (isBrowserSupported) return null;

  return (
    <div className={classnames(classes.unsupportedDiv, className)}>
      <Typography className={classnames(classes.unsupportedBody, extraClasses.text)} variant="body1">
        Sorry, but your browser version doesn&#x27;t support telehealth. For this feature to work, please upgrade to{' '}
        <Link
          href="https://www.google.com/chrome/"
          underline="always"
          variant="body1"
          className={classnames(classes.unsupportedBody, extraClasses.text)}
        >
          Google Chrome
        </Link>
        ,{' '}
        <Link
          href="https://www.mozilla.org/en-US/firefox/new/"
          underline="always"
          variant="body1"
          className={classnames(classes.unsupportedBody, extraClasses.text)}
        >
          Mozilla Firefox
        </Link>{' '}
        or{' '}
        <Link
          href="https://support.apple.com/downloads/safari"
          underline="always"
          variant="body1"
          className={classnames(classes.unsupportedBody, extraClasses.text)}
        >
          Safari
        </Link>
        .
      </Typography>
    </div>
  );
};

export default withStyles(useStyles)(TelehealthBrowserNotSupportedBanner);
